module.exports = __webpack_public_path__ + "img/Proliferation-OPSCC_PMID37704757.4ea9cf5a.png";